import React, { useRef } from 'react';
import OverallRating from 'src/modules/parkplusStoreV2/uiComponents/OverallRating';
import ProductReview from 'src/modules/parkplusStoreV2/uiComponents/ProductReview';
import Modal from 'ui-v2/components/Modal';
import s from './AllReviewPopup.module.scss';
import { trackSectionViewedStoreV2 } from 'src/modules/parkplusStoreV2/utils/events';
import { StateType } from '../Reviews/types';
import { Divider } from 'ui-v2/components/Divider';
import { Loader } from 'ui-v2/components/Loader';

type AllReviewPopupType = {
  show: boolean;
  onClose: () => void;
  state: StateType;
  loadMore: () => void;
  onImageClick?: (item: string) => void;
};
export const AllReviewPopup = ({
  show,
  onClose,
  state,
  loadMore,
  onImageClick,
}: AllReviewPopupType) => {
  const isEventFired = useRef(false);
  const loadItems = (e) => {
    if (
      //@ts-ignore
      e.target.scrollTop >=
      //@ts-ignore
      e.target.scrollHeight - e.target.offsetHeight - 150
    ) {
      if (state.hasMore && !state.loading) {
        loadMore();
      }
      if (!isEventFired.current) {
        trackSectionViewedStoreV2('review_popup', {
          scroll: 'true',
        });
        isEventFired.current = true;
      }
    }
  };
  return (
    <Modal
      show={show}
      head={{
        show: true,
        onClose: onClose,
      }}
      variant="page"
      rootStyle={{
        zIndex: 10,
      }}
      animation={{
        type: 'rtl',
      }}
    >
      <div
        className={s.root}
        onScroll={(e) => {
          loadItems(e);
        }}
      >
        <OverallRating ratingData={state.ratingData} />
        {!!state.ratingData?.avgRating && <Divider variant="padded" />}
        {state.reviewsData.map((item, index) => (
          <ProductReview key={index} data={item} onImageClick={onImageClick} />
        ))}

        {state.loading && (
          <div className={s.loader}>
           <Loader/>
          </div>
        )}
      </div>
    </Modal>
  );
};
